<div class="object-content-list-source-array-filter">
  <button
    mat-stroked-button
    [matMenuTriggerFor]="sourceFilter"
    (menuOpened)="dropdownMenu = true;"
    (menuClosed)="dropdownMenu = false;"
    class="object-content-list-source-array-filter__button"
    [ngClass]="{'active': dropdownMenu}"
  >
    <mat-icon class="object-content-list-source-array-filter__button-icon">
      filter_alt
    </mat-icon>

    <span class="object-content-list-source-array-filter__button-text">
      {{ 'TRANS__FILTER__FILTRATE' | translate }}
    </span>

    <mat-icon class="object-content-list-source-array-filter__button-arrow">
      {{dropdownMenu ? 'expand_less' : 'expand_more'}}
    </mat-icon>
  </button>

  <mat-menu #sourceFilter="matMenu">
    <mat-accordion class="object-content-list-source-array-filter__accordion" displayMode="flat">
      @for (filterGroup of contentListSource.filterGroups; track $index) {
        <mat-expansion-panel
          #currentPanel
          (click)="$event.stopPropagation()"
          (keydown)="null"
          (opened)="setStep($index)"
          class="no-active-blue-color object-content-list-source-array-filter__panel"
          [class.is-expanded]="currentPanel.expanded"
          [class.is-collapsed]="!currentPanel.expanded"
        >
          <mat-expansion-panel-header
            [collapsedHeight]="'40px'"
            [expandedHeight]="'40px'"
          >
            <mat-panel-title>
              {{ filterGroup.title | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          @for (filterField of filterGroup.filters; track $index) {
            <ul class="object-content-list-source-array-filter__items">
              @for (item of filterField.items; track $index) {
                <li class="object-content-list-source-array-filter__item">
                  <mat-checkbox
                    (click)="setFilter($event, item)"
                    (keydown)="null"
                    [checked]="item.selected"
                  >
                    @if (item.name) {
                      <span [ngClass]="{'bold': item.selected}">
                        {{ item.name | translate }}
                      </span>
                    }

                    @if (item.count) {
                      <span
                        class="object-content-list-source-array-filter__countText"
                        [ngClass]="{'bold': item.selected}"
                      >
                        ({{item.count}})
                      </span>
                    }
                  </mat-checkbox>
                </li>
              }
            </ul>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </mat-menu>
</div>
